import { useWarehouses } from "./useWarehouses";

export function useWarehouseFromWarehouseId(warehouseId?: string) {
  const { warehouses } = useWarehouses();
  return warehouses.find((warehouse) => warehouse.id === warehouseId);
}
